"use client";
import React from "react";
import { motion } from "framer-motion";

const HeaderInner = ({ title, shortDescription }) => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <section
      className="position-relative text-white"
      style={{
        backgroundImage: "url(/assets/images/banner/banner-inner-page.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        paddingTop: "100px",
        paddingBottom: "100px",
      }}
    >
      {/* Animated Shapes */}
      <motion.img
        src="/assets/images/banner/inner-banner-shape2.png"
        alt="shape"
        className="position-absolute top-0 start-0"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.5 }}
      />

      <motion.img
        src="/assets/images/banner/inner-banner-shape1.png"
        alt="shape"
        className="position-absolute top-0 start-0"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.5, delay: 0.2 }}
      />

      <motion.img
        src="/assets/images/banner/inner-banner-shape3.png"
        alt="shape"
        className="position-absolute top-0 end-0"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.5, delay: 0.2 }}
      />

      {/* Content */}
      <div className="container position-relative z-1">
        <motion.h2
          className="fw-bold display-5"
          style={{ color: "#fff" }}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {title}
        </motion.h2>

        <motion.div
          className=" small d-flex gap-2"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          style={{marginTop:-10}}
        >
          {/* Example breadcrumb */}
          {/* <a href="/" className="text-decoration-underline text-white">Home</a> */}
          <span></span>

          <span style={{ color: "navy" }} className="fs-4">{shortDescription}</span>
        </motion.div>
      </div>
    </section>
  );
};

export default HeaderInner;
